import permissionSelectRenderer from '../tableRenderers/permissionSelectRenderer';

// @TODO_PERMISSSION: Add name to settings;

const NAMES_MAP = {
  PLATFORM_ADMIN: 'Platform Admin',
};

const getName = settings =>
  settings.name || NAMES_MAP[settings.scope] || settings.scope;

const ProductAccessSwitcher = ({ settings, options }) => {
  const permissionSelect = permissionSelectRenderer({
    options,
    actionName: options[0].label,
    showLabels: true,
    productScope: settings.scope,
    label: `- allow access to ${getName(settings)}`,
  });

  return permissionSelect({
    cellData: settings.value,
    rowData: settings,
  });
};

export default ProductAccessSwitcher;
